import { Controller } from '@hotwired/stimulus';
import csrfToken from '../../modules/csrf';

export default class extends Controller {
  static targets = ['captchaError', 'emailField', 'submitButton'];

  static values = {
    validateUrl: String,
  };

  captchaPerformedSuccessfully = false;

  submitter;

  validationPerformedSuccessfully = false;

  async onSubmit(event) {
    // NOTE: This is a workaround for the issue that the form is submitted again when requestSubmit is called
    if (this.validationPerformedSuccessfully && this.captchaPerformedSuccessfully) return;

    event.preventDefault();
    event.stopPropagation();

    this.submitter = event.submitter;
    this.#disableSubmitButtons();

    await this.#validateForm();
  }

  captchaComplete() {
    this.captchaErrorTarget.classList.add('d-none');
    this.captchaPerformedSuccessfully = true;

    this.#submitForm();
  }

  captchaExpired() {
    this.captchaPerformedSuccessfully = false;
  }

  async #validateForm() {
    this.validationPerformedSuccessfully = this.#handleValidation(await this.#fetchValidation());
    this.#submitForm();
  }

  #handleValidation({ isValid, errors }) {
    this.element.querySelectorAll('cmpr-form-hint').forEach((e) => e.remove());

    this.emailFieldTarget.classList.remove('is-invalid');

    if (errors.has('email_address')) {
      this.emailFieldTarget.classList.add('is-invalid');
      const hint = `<cmpr-form-hint variant="error">${errors.get('email_address')}</cmpr-form-hint>`;
      this.emailFieldTarget.insertAdjacentHTML('afterend', hint);
    }

    return isValid;
  }

  async #fetchValidation() {
    const response = await fetch(this.validateUrlValue, {
      method: 'post',
      body: new FormData(this.element),
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': csrfToken(),
      },
    });

    const json = await response.json();

    if (response.ok) {
      const errors = new Map(Object.entries(json));
      return { isValid: errors.size === 0, errors };
    }

    window.location.replace(window.location);
    throw new Error('Validation request failed');
  }

  #submitForm() {
    if (this.validationPerformedSuccessfully && this.captchaPerformedSuccessfully) {
      this.element.requestSubmit(this.submitter);
    }

    this.#enableSubmitButtons();
  }

  #enableSubmitButtons() {
    setTimeout(() => {
      this.submitButtonTargets.forEach((submitButton) => {
        const submitButtonElement = submitButton;
        submitButtonElement.disabled = false;
      });
    }, 500);
  }

  #disableSubmitButtons() {
    this.submitButtonTargets.forEach((submitButton) => {
      const submitButtonElement = submitButton;
      submitButtonElement.disabled = true;
    });
  }
}
